<template>
    <div></div>
</template>

<script>
    export default {
        name: "Logout",
        async beforeMount() {
            await this.$store.dispatch('authLogout');
            return this.$router.push('/auth/login');
        },
    }
</script>